<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    [formGroup]="groupEditInfo"
    (ngSubmit)="onSubmit(true)"
    #groupEditForm="ngForm"
    onsipFormTracking
    name="admin-groups-edit"
    id="admin-groups-edit"
  >
    <div class="edit" onsip-grid-placement-shelf>
      <div class="first-column">
        <section class="group-name with-mat-form-field">
          <div class="mat-body-1">{{ "ONSIP_I18N.NAME" | translate }}</div>
          <mat-form-field appearance="outline">
            <input
              matInput
              [attr.data-cy]="E2eLocators.ADMIN_GROUP_EDIT_SHELVE_NAME"
              required
              placeholder="{{ 'ONSIP_I18N.GROUP_NAME' | translate }}"
              autocomplete="off"
              formControlName="name"
            />
            <mat-error>{{ getNameError() }}</mat-error>
          </mat-form-field>
        </section>
        <section class="ring-fields-container mb-28">
          <div class="mat-body-1">
            {{ "ONSIP_I18N.RING_STRATEGY" | translate }}
            <mat-icon
              [matTooltip]="
                'ONSIP_I18N.SIMULTANEOUS_RING_RINGS_ALL_MEMBERS_AT_THE_SAME_TIME_HUNT_GROUP_RINGS_EACH_MEMBER_SEQUENTIALLY'
                  | translate
              "
              matTooltipClass="onsip-tooltip-background"
              [matTooltipPosition]="'above'"
              >help_outline
            </mat-icon>
          </div>
          <mat-radio-group color="primary" formControlName="ordering">
            <mat-radio-button value="parallel">
              {{ "ONSIP_I18N.SIMULTANEOUS_RING" | translate }}
            </mat-radio-button>
            <mat-radio-button value="sequential">
              {{ "ONSIP_I18N.HUNT_GROUP" | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </section>
        <section class="ring-duration-container with-mat-form-field">
          <div class="mat-body-1">
            {{ "ONSIP_I18N.RING_DURATION" | translate }}
            <mat-icon
              [matTooltip]="
                'ONSIP_I18N.SETS_THE_AMOUNT_OF_TIME_CALLS_RING_FOR_EACH_MEMBER' | translate
              "
              matTooltipClass="onsip-tooltip-background"
              [matTooltipPosition]="'above'"
              >help_outline
            </mat-icon>
          </div>
          <div class="ring-duration-field">
            <mat-form-field appearance="outline">
              <mat-select formControlName="timeout">
                @for (duration of durationArr; track duration) {
                <mat-option [value]="duration">
                  {{ duration }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="mat-body-1 tag">{{ "ONSIP_I18N.SECONDS" | translate | lowercase }}</span>
          </div>
        </section>
        <section class="failover-container with-mat-form-field">
          <div class="mat-body-1">
            {{ "ONSIP_I18N.FAILOVER" | translate | titlecase }}
            <mat-icon
              [matTooltip]="
                'ONSIP_I18N.FAILOVER_TAKES_EFFECT_AFTER_THE_WHOLE_GROUP_HAS_BEEN_EXHAUSTED_IF_NO_FAILOVER_IS_SET_THE_CALL_IS_THEN_ENDED'
                  | translate
              "
              matTooltipClass="onsip-tooltip-background"
              [matTooltipPosition]="'above'"
              >help_outline
            </mat-icon>
          </div>
          <onsip-address-autocomplete class="group-failover" formControlName="defaultAddress">
          </onsip-address-autocomplete>
        </section>
      </div>
      <div class="second-column">
        <section class="sip-container with-mat-form-field">
          <div class="mat-body-1">{{ "ONSIP_I18N.SIP_ADDRESS" | translate }}</div>
          <div class="sip-address-field">
            <onsip-sip-address-field formControlName="sipAddress"> </onsip-sip-address-field>
          </div>
        </section>
        <section class="ext-container with-mat-form-field">
          <div class="mat-body-1">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
          <onsip-extensions-list
            #extensionsList
            formControlName="extensions"
            [currentId]="group.address.addressId"
          >
          </onsip-extensions-list>
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <button mat-button type="button" (click)="onSubmit(false)" color="primary">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button
        mat-flat-button
        type="submit"
        class="toggle-button"
        color="primary"
        [attr.data-cy]="E2eLocators.ADMIN_GROUP_EDIT_SHELVE_SUBMIT"
      >
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
